import { __decorate } from "tslib";
import Avatar from "@/components/Avatar.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import Money from "@/components/Money.vue";
let CustomerCard = class CustomerCard extends Vue {
    customer;
    size;
    balance;
    avatarShown;
    get avatarSize() {
        return `avatar-${this.size}`;
    }
};
__decorate([
    Prop({ type: Object, required: true })
], CustomerCard.prototype, "customer", void 0);
__decorate([
    Prop({ type: String, default: 'xs' })
], CustomerCard.prototype, "size", void 0);
__decorate([
    Prop(Boolean)
], CustomerCard.prototype, "balance", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], CustomerCard.prototype, "avatarShown", void 0);
CustomerCard = __decorate([
    Component({
        components: { Money, Avatar },
    })
], CustomerCard);
export default CustomerCard;
